import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Come prenoto un esame con la Dott.ssa Dal Bello?",
    a: "Le prenotazioni avvengono direttamente presso la sede in cui desideri eseguire l'esame. Nella sezione 'Sedi' trovi i link ufficiali di Casa di Cura Palazzolo e Life Clinic. Per appuntamenti presso lo studio del Dr. Berbenni puoi utilizzare il modulo di contatto qui sotto.",
  },
  {
    q: "Dove posso eseguire RM e mammografia con la Dott.ssa Dal Bello?",
    a: "La Risonanza Magnetica e la mammografia (tomosintesi e CESM) sono eseguibili esclusivamente presso la Casa di Cura Palazzolo di Bergamo. Presso Life Clinic e lo studio del Dr. Berbenni eseguo invece le prestazioni ecografiche.",
  },
  {
    q: "Come devo prepararmi all'esame di Risonanza Magnetica?",
    a: "Le preparazioni variano in base al distretto esaminato. In generale è necessario portare la documentazione clinica precedente, eventuali referti di esami simili e segnalare la presenza di protesi, pacemaker o impianti metallici. La preparazione specifica viene comunicata dalla segreteria al momento della prenotazione.",
  },
  {
    q: "Cosa è la mammografia con mezzo di contrasto (CESM)?",
    a: "La CESM (Contrast-Enhanced Spectral Mammography) è una mammografia di secondo livello eseguita con somministrazione di mezzo di contrasto iodato. Migliora sensibilmente la rilevazione di lesioni in seni densi o in casi selezionati di sorveglianza, ed è una valida alternativa alla RM mammaria in pazienti che non possono effettuarla.",
  },
  {
    q: "I bambini possono fare ecografie con lei?",
    a: "Sì. Eseguo lo screening neonatale per la displasia congenita dell'anca e altri esami ecografici pediatrici di mia competenza, in ambiente accogliente e con tempi dedicati alla famiglia.",
  },
  {
    q: "Lavora con strumenti di intelligenza artificiale?",
    a: "Sì, collaboro con aziende e gruppi di ricerca alla validazione di strumenti di AI applicati alla radiologia. L'AI è un supporto al medico, non un sostituto: il referto resta sempre un atto clinico, firmato da un Medico Radiologo.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-32 border-t border-stone-200 bg-white"
    >
      <div className="mx-auto max-w-5xl px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl">
          <span className="eyebrow">Domande frequenti</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-stone-900 leading-[1.1]">
            Le risposte alle domande che mi vengono fatte più spesso.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-12 divide-y divide-stone-200 border-t border-b border-stone-200"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-0 px-1"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-base md:text-lg font-medium font-display text-stone-900 py-6 hover:no-underline hover:text-[#3E615B]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-stone-600 text-[15px] leading-relaxed pb-6 pr-6"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
